import { Component, h } from 'preact'
import { PostType } from './Types'
import Content from '../common/Content'
import PostEditor from '../editor/postEditorViaAPI'
import PostAuthor from './PostAuthorAvatar'
import PostAuthorMeta from './PostAuthorMeta'
import Axios from 'axios'
import LikedUsers, { LikedUserType } from '../topic-list-view/LikedUsers'
import Phrase from '../../libs/translationsUtils/phrase'
import classNames from 'classnames'
import PinnedReplyLabel from '../pinned-reply/PinnedReplyLabel'
import { canUserEditPost } from '../utils/permissions'
import { ContentType } from '@insided/shared/utils/contentType'
import PostActions from '../content/post-actions.sync'

interface Props {
  type: ContentType
  currentUser: LikedUserType
  displayAuthor: boolean
  isLastItem: boolean
  topicId: number
  reply: PostType
  isPinned?: boolean
}

interface State {
  showEditor: boolean
  isCurrentUserLiked: boolean
  likedUsers: {
    [key: string]: LikedUserType
  }
  content: string
}

class TopicReply extends Component<Props, State> {
  private readonly canUserEditPost: boolean = canUserEditPost()
  constructor (props: Props) {
    super(props)
    this.state = {
      showEditor: false,
      isCurrentUserLiked: this.props.currentUser.id !== null && this.props.reply.likedBy.includes(this.props.currentUser.id.toString()),
      likedUsers: {},
      content: props.reply.content
    }

    this.toggleLikeStatus = this.toggleLikeStatus.bind(this)
  }

  async toggleLikeStatus () {
    if (this.state.isCurrentUserLiked) {
      delete this.state.likedUsers[this.props.currentUser.id]
      this.setState({
        likedUsers: this.state.likedUsers,
        isCurrentUserLiked: false
      })
    } else {
      this.setState({
        likedUsers: {
          ...this.state.likedUsers,
          [this.props.currentUser.id]: this.props.currentUser
        },
        isCurrentUserLiked: true
      })
    }
  }

  async componentDidMount () {
    if (this.props.reply.likedBy.length) {
      const res = await Axios.get('/member/getUsersById', {
        params: {
          ids: this.props.reply.likedBy
        }
      })

      this.setState({ likedUsers: res.data })
    }
  }

  render () {
    const { topicId, reply, displayAuthor, isLastItem, type, isPinned } = this.props
    const { content, showEditor, isCurrentUserLiked, likedUsers } = this.state

    return (
      <div
        id={`post${reply.id}`} className={classNames(
          'post', 'box__pad', 'qa-topic-post-box',
          { 'post--pinned': isPinned }
        )}
      >
        <div className='post__user__info'>
          <PostAuthor author={reply.author} />
        </div>
        <PostAuthorMeta {...reply.author} displayAuthor={displayAuthor} repliedAt={reply.repliedAt} />
        {
          showEditor
            ? (
              <div className='post__content post__edit'>
                <PostEditor
                  type={type}
                  data={content}
                  disableFileAttachments={false}
                  topicId={topicId}
                  replyId={parseInt(reply.id)}
                  isControl={false}
                  onSuccess={(content) => this.setState({ showEditor: false, content })}
                  onCancel={() => this.setState({ showEditor: false })}
                  redirect={false}
                  isGuest={false}
                />
              </div>
              )
            : (
              <div>
                {isPinned && <div className='pinned-reply__label--comments'>
                  <PinnedReplyLabel phrase={<Phrase p='reply.pinned' m='Forum' />} />
                </div>}
                <Content
                  content={content || ''}
                  className={classNames('post__content', 'qa-topic-post-content', 'post__content--new-editor')}
                />
              </div>
              )
        }
        {
          Object.keys(likedUsers).length
            ? (
              <LikedUsers likedUsers={Object.keys(likedUsers).map(id => likedUsers[id])} previewCount={3} isCurrentUserLiked={isCurrentUserLiked} />
              )
            : null
        }
        <div className='post__footer'>
          <PostActions
            privateReplyId={parseInt(reply.id)}
            postId={parseInt(reply.publicReplyId)}
            contentType={type}
            onEditClick={() => this.setState({ showEditor: true })}
            isLiked={isCurrentUserLiked}
            onLikeClick={this.toggleLikeStatus}
            showLike
            showReport={false}
            showBestAnswer={false}
            quoteText={reply.content}
            quoteUsername={reply.author.username}
            showEdit={this.canUserEditPost}
          />
        </div>
        <hr className={`seperator m-b-0 ${isLastItem ? 'is-transparant' : ''}`} />
      </div>
    )
  }
}

export default TopicReply
